import {
    Component,
    ElementRef,
    HostBinding,
    Inject,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewEncapsulation,
} from "@angular/core";
import { Subscription } from "rxjs";
import { WtfConfigService } from "../../services/core/config.service";
import { Platform } from "@angular/cdk/platform";
import { DOCUMENT } from "@angular/common";
import { StateService } from "../../services/state/state.service";

@Component({
    selector: "wtf-main",
    templateUrl: "./main.component.html",
    styleUrls: ["./main.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class WtfMainComponent implements OnInit, OnDestroy {
    onSettingsChanged: Subscription;
    wtfSettings: any;
    @HostBinding("attr.wtf-layout-mode") layoutMode;

    constructor(
        private _renderer: Renderer2,
        private _elementRef: ElementRef,
        private wtfConfig: WtfConfigService,
        private stateService: StateService,
        private platform: Platform,
        @Inject(DOCUMENT) private document: any
    ) {
        this.onSettingsChanged = this.wtfConfig.onSettingsChanged.subscribe(
            (newSettings) => {
                this.wtfSettings = newSettings;
                this.layoutMode = this.wtfSettings.layout.mode;
            }
        );

        if (this.platform.ANDROID || this.platform.IOS) {
            this.document.body.className += " is-mobile";
        }
    }

    get toolbarDisplay(): boolean {
        return this.stateService.showToolbar;
    }

    ngOnInit() {}

    ngOnDestroy() {
        this.onSettingsChanged.unsubscribe();
    }

    addClass(className: string) {
        this._renderer.addClass(this._elementRef.nativeElement, className);
    }

    removeClass(className: string) {
        this._renderer.removeClass(this._elementRef.nativeElement, className);
    }
}
